import styles from './navbar.module.scss'
import { Link, useLocation } from 'react-router-dom'
const NAV_ITEMS = [
	{
		label: 'Home',
		path: 'https://www.ontimebride.com/',
	},
	{
		label: 'About',
		path: 'https://www.ontimebride.com/about',
	},
	{
		label: 'Pricing',
		path: 'https://www.ontimebride.com/pricing',
	},
	{
		label: 'Vendors',
		path: 'https://www.ontimebride.com/vendors',
	},
	{
		label: 'Resources',
		path: 'https://www.ontimebride.com/resources',
	},
]
export const NavItems = () => {
	const { pathname } = useLocation()
	return (
		<>
			<ul className={styles.navItems}>
				{NAV_ITEMS.map((item) => {
					return (
						<li>
							<Link
								to={item.path}
								className={
									pathname === item.path ? styles.active : ''
								}
								data-cy={`go-to-${item.label.toLowerCase()}`}
							>
								{' '}
								{item.label}{' '}
							</Link>
						</li>
					)
				})}
			</ul>
		</>
	)
}
